import { TSuggest } from 'feature/registration/types'

// для хранение и работы с заявкой
export namespace orderFormSpace {
  // виды заявок (параметр для бека)
  export enum OrderType {
    new = 'ORDERING',
    service = 'SERVICE',
    consultation = 'CONSULTATION',
    newCompany = 'ORDERING',
  }

  // виды форм (параметр для хранения)
  export enum FormType {
    new = 'new',
    service = 'service',
    newCompany = 'newCompany',
  }
  export type UserType = 'personal' | 'company'

  // содержимое формы
  export interface FormsType {
    // тип формы (для бека)
    type: FormType
    // текущий шаг
    activeStep: number
    // выбранные продукты
    products: Product[]
    // выбранные параметры
    params: Parameter[]
    // изображения (для параметров)
    images: Images[]
    // адрес заявки
    address: TSuggest | null
    // временные слоты
    timeSlots: TimeSlot[]
    // регион временных слотов
    timeSlotsRegionFiasId: string | null
    // код дилера
    dealerCode: string
    // номер телефона
    phone: string
    // почта
    email: string
    // тип пользователя (ФЛ/ЮЛ), выбирается неавторизованным через модал
    userType: UserType | null
    // id банковских реквизитов (для авторизованного ЮЛ)
    bankDetailsId: number | null
  }

  export enum ConsultationFormType {
    consultation = 'consultation',
    consultationProduct = 'consultationProduct',
  }
  export interface ConsultationsFormType {
    type: ConsultationFormType
    comment: string
    products: Product[] | null
    images: Images[]
  }
  export interface State {
    forms: {
      [key in FormType]: FormsType
    }
    consultationForms: {
      [key in ConsultationFormType]: ConsultationsFormType
    }
    currentEditForm: FormType
    currentEditConsultForm: ConsultationFormType
    currentSendForm: FormType | ConsultationFormType
  }
  export interface Product {
    id: number
    name: string
  }
  export interface Parameter {
    id: number
    name: string
    iconUrl: string
    productId: number
    type: string
    value: string | number | boolean | null
    selectId?: number
  }
  export interface Images {
    id: string
    productId?: number
    paramId?: number
    name: string
    serverUid: null | string
    previewUrl: string | null
    size: string
    mimeType?: string
  }

  // export interface ConsultationImage {
  //   uid: string | null
  //   previewUrl: string | null
  // }

  export interface TimeSlot {
    key: string
    id?: number
    value?: string
    date?: string | null
    isValidDate?: boolean
  }
}
